import { Component, OnInit, Input, ViewChild, ContentChild, Output, EventEmitter } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { UntypedFormControl } from '@angular/forms';
import { Moment } from 'moment'

@Component({
  selector: 'velocity-datepickerhidden',
  templateUrl: './datepickerhidden.component.html',
  styleUrls: ['./datepickerhidden.component.scss']
})
export class DatePickerHiddenComponent implements OnInit {

  public date = new UntypedFormControl(new Date())
  @ViewChild(MatDatepicker, { static: false }) dp: MatDatepicker<Date>;

  @Input() dt: Date;
  @Output() dtChanged: EventEmitter<Date> = new EventEmitter<Date>();

  ngOnInit() {
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Moment>) {
    this.dtChanged.emit(normalizedMonth);
    datepicker.close();
  }
}
